import { createApp } from 'vue'
import * as Sentry from "@sentry/vue";

import Clarity from "@microsoft/clarity";

import './assets/scss/style.scss';
import vuetify from "@/plugins/vuetify.ts";
import router from './router';
import '@Gelios-Platform/gelios-calendar-component/style.css';
import App from './App.vue'
import { createPinia } from 'pinia';
import "vue-multiselect/dist/vue-multiselect.min.css";
import Notifications from '@kyvg/vue3-notification'
import i18n from '@/locales/vue-i18n.js';
import { GeliosCalendar } from '@Gelios-Platform/gelios-calendar-component';

const pinia = createPinia();
const app = createApp(App);

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const sentryEnv = import.meta.env.VITE_SENTRY_ENV;

const clarityId = import.meta.env.VITE_CLARITY_PROJECT_ID;

if (sentryDsn) {
    Sentry.init({
        app,
        dsn: sentryDsn,
        environment: sentryEnv,
        sendDefaultPii: true,
        ignoreErrors: [
            'Error invoking post: Method not found',
            'invokePost',
            'JavaBridge',
            'Unable to preload CSS',
            'Failed to fetch dynamically imported module',
            'Importing a module script failed',
        ],
        beforeSend(event, hint) {
            const error = hint.originalException;
            if (
                error &&
                typeof error === 'string' &&
                error.includes('Error invoking post: Method not found')
            ) {
                return null;
            }
            return event;
        },
    });
}

if (clarityId) {
    Clarity.init(clarityId);
}

app
    .use(GeliosCalendar, {
        apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
        authBaseUrl: import.meta.env.VITE_API_BASE_URL,
        locale: localStorage.getItem('selectedLanguage') || 'uk',
        i18n: i18n,
    })
    .use(i18n)
    .use(Notifications)
    .use(vuetify)
    .use(router)
    .use(pinia)
    .mount("#app");